import React from "react";
import { User } from "firebase/auth";

import { useGetUser, useLocalStorage } from "@hooks";
import { AuthContext } from "./AuthContext";

/**
 * Standalone component to hold auth information and provide it to the rest of the application.
 * @param children Child components in the React tree.
 */
function AuthProvider({ children }: React.PropsWithChildren) {
  const [user, setUser] = useLocalStorage<User | null>("user", null);
  const authUser = useGetUser(user ? user.uid : "");
  const authContextValue = React.useMemo(
    () => ({
      authUser,
      user,
      setUser: (user: User) => setUser(user),
      clearUser: () => setUser(null),
    }),
    [user, setUser, authUser],
  );

  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
}

export { AuthProvider };
